import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'm-stats-item',
    templateUrl: './m-stats-item.component.html',
    styleUrls: ['./m-stats-item.component.scss'],
    standalone: false
})
export class MStatsItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
